(function($) {

  const debounce = (func, wait) => {
        let timeout;

        return function executedFunction(...args) {

            const later = () => {
                timeout = null;

                func(...args);
            };

            clearTimeout(timeout);

            timeout = setTimeout(later, wait);
        };
    };

  function setupCollapsableMenus () {

    document.querySelectorAll('.sub-menu-container .sub-menu-inner').forEach(function (el) {
      let $el = $(el)

      if(window.innerWidth < 768 && !el.classList.contains('collapse')) {
        $el.before(
          $('<button>', {
            text: wp.i18n.__('In this section', 'motimate'),
            type: 'button',
            class: 'sub-menu-toggle',
            'data-toggle': 'collapse',
            'data-target': `#${el.id}`,
            'aria-expanded': false,
            'aria-controls': el.id
          })
        )

        $el.collapse({ toggle: false })

        el.classList.add('collapse')
      }

      else if(window.innerWidth >= 768 && el.classList.contains('collapse')) {
        $el.collapse('show').collapse('dispose')

        el.parentNode.removeChild(el.parentNode.querySelector('.sub-menu-toggle'))

        el.classList.remove('collapse')
      }
    })

  }


  document.addEventListener('DOMContentLoaded', function () {
    setupCollapsableMenus()

    window.addEventListener('resize', debounce(setupCollapsableMenus, 100))
  })

})(jQuery)